module.exports = __webpack_public_path__ + "static/media/gameplay.c55c5dd9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/trajectile-command/gameplay.gif
// module id = 805
// module chunks = 0